/* @ngInject */
export default function NvRhs() {

}
